export default {
  PortalAdmin: 'portal-admin',
  PortalOrg: 'portal-org',
  Platform: 'platform',
  PlatformPM: 'platform-pm',
  PlatformSC: 'platform-sc'
}
